var Backbone = require('backbone');


var DocumentTypeModel = Backbone.Model.extend({

    urlRoot: '/api/document/type',

    defaults: {
        id: undefined,
        organizationId: undefined,
        name: undefined,
        object: {
            signsLimit: 1,
            signX: 105,
            signY: 40,
            signWidth: 400
        }
    },

});


module.exports = DocumentTypeModel;


//////////////////
// WEBPACK FOOTER
// ./app/models/document-type-model.js
// module id = 400
// module chunks = 0